import {createContext, type PropsWithChildren, type RefObject, use, useRef} from 'react'
import type {IssueCommentComposerHandle} from '../comments/IssueCommentComposer'

const OverviewCommentComposerRefContext = createContext<RefObject<IssueCommentComposerHandle | null> | null>(null)

export function OverviewCommentComposerProvider({children}: PropsWithChildren) {
  const composerRef = useRef<IssueCommentComposerHandle>(null)

  return <OverviewCommentComposerRefContext value={composerRef}>{children}</OverviewCommentComposerRefContext>
}

export function useOverviewCommentComposerRef() {
  return use(OverviewCommentComposerRefContext)
}
